export const visit = (vm, at) => {
vm(require("./availability/fi.lyaml"));
vm(require("./typical-response-time/fi.lyaml"));
vm(require("./default/fi.lyaml"));
at({ "fi": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "ok" } } });
};